import React, { useState } from "react";
import "../css/Map.css"
import Pinned from '../assets/cbu/map.png'
import { motion } from "framer-motion"

const Map = () => {
  var [gender,setMap]=useState();
 
  return (
    <section id="lokasi" class="bg-white">
    <div id="lokasi" className="lokasi" style={{background:"#e8e8e4", paddingTop:'30px', tBottom:'50px'}}>
      
      <div class="row justify-content-between p-5">
            <div class="col">
              <div class="gambarpin d-flex justify-content-center">
                <motion.img src={Pinned} alt="..." 
                      initial={{ opacity: 0 }} // Starting state
                      whileInView={{ opacity: 1, transition: {delay:0.5, duration:0.6}}} // When the element comes 
                      into view
                      transition={{ duration: 0.3 }}
                      useMotionValueEvent={{y:'100px'}}
                />
              </div>
            </div>
            <div class="col about_cbu">
                <div>
                  <p class="text-start">PT. Cakra Buana Unggul penyedia jasa sewa kendaraan yang berpengalaman lebih dari 10 tahun, dengan dukungan armada yang sangat mumpuni mampu menyedikan kendaaaran Hiace buat kita semua dan menjalankan amanah dengan baik</p>
                </div>
                <div>
                  <label><input  type="radio" name="check" value="2" onChange={check=>setMap(check.target.value)} /><u>Tangerang Selatan</u></label>
                  <label><input  type="radio" name="check" value="1" onChange={check=>setMap(check.target.value)} /><u>Sukabumi</u></label>
         
                </div>

            </div>
      
      </div>

       
        
      
     
        
        <div class="d-flex justify-content-center">
                  { gender === "1" ? (
                    
                    <iframe
                    name="sukabumi"
                    title="Cakra l"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.6928721058143!2d106.9458539!3d-6.927266999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e684965a795f57b%3A0x273ddc7cadd3de7!2sSewa%20mobil%20Hiace%20dan%20Elf%20long%20Sukabumi!5e0!3m2!1sid!2sid!4v1736791735549!5m2!1sid!2sid" 
                  width="120%"
                height="500"
                style={{ border: 5 }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>

              ) : (
                <iframe 
                name="cakra"
                title="Cakra Buana Unggul"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.091414758277!2d106.7177717!3d-6.251684900000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69fb78ea60b5e9%3A0x5fb34825ebc48053!2sCakra%20Buana%20Motor%20Japos!5e0!3m2!1sen!2sid!4v1736395314801!5m2!1sen!2sid"
           

                width="120%"
         height="500"
                style={{ border: 5 }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade" >
                </iframe>
              

              )}
         
         </div>
      
   
    </div>
   

    </section>

      
  );
};
export default Map;